/**
 * NotFoundPage.tsx — Página 404 do site Nectaris
 * Adaptada ao Claude Design (light bg + seção dark para CTA)
 */

import { NavLink } from "react-router";

export function NotFoundPage() {
  return (
    <section
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "100px 32px",
        textAlign: "center",
        gap: "24px",
        background: "#0B1B2B",
        color: "#F2F6F8",
      }}
    >
      <p
        style={{
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: "13px",
          letterSpacing: "0.2em",
          textTransform: "uppercase",
          color: "#37B7D6",
          margin: 0,
        }}
      >
        Erro 404
      </p>
      <h1
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "clamp(36px, 5vw, 64px)",
          fontWeight: 700,
          color: "#FFFFFF",
          letterSpacing: "-0.02em",
          margin: 0,
          lineHeight: 1.08,
        }}
      >
        Página não encontrada
      </h1>
      <p
        style={{
          fontFamily: "Inter, sans-serif",
          fontSize: "18px",
          color: "rgba(230,239,244,.72)",
          maxWidth: "44ch",
          lineHeight: 1.65,
          margin: 0,
        }}
      >
        A página que você procura não existe ou foi movida. Volte para a
        página inicial do Nectaris Group.
      </p>
      <NavLink
        to="/"
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: 700,
          fontSize: "17px",
          background: "#E0A43B",
          color: "#0B1B2B",
          borderRadius: "12px",
          padding: "16px 34px",
          textDecoration: "none",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        Voltar ao início
      </NavLink>
    </section>
  );
}
